import './components/Loader.js'

export function formatValue(val, type = 'decimal') {
    const remainder = String(val).length % 4
    const decimalRestriction = (val > 999 && remainder > 0) ? 1 : 0
    const notationType = (String(val).length > 4) ? 'compact' : 'standard'

    let props = {
        style: 'decimal', 
        maximumFractionDigits: 0
    }

    if(type === 'decimal') {
        props = {
            notation: notationType,
            compactDisplay: 'short',
            minimumFractionDigits: decimalRestriction,
            maximumFractionDigits: decimalRestriction,
        }
    }
    
    if(type === 'currency') {
        props = {
            style: 'currency', 
            notation: notationType,
            compactDisplay: 'short',
            minimumFractionDigits: decimalRestriction,
            maximumFractionDigits: decimalRestriction,
            currency: 'USD'
        }

        val = Math.round(val)
    }

    if(type === 'percent') {
        props = {
            style: 'percent', 
            minimumFractionDigits: (val < 100) ? 1 : 0,
            maximumFractionDigits: (val < 100) ? 1 : 0
        }
    }

    if(type === 'longform') {
        props = {
            maximumFractionDigits: 2,
        }
    }

    if(type === 'longformCurrency') {
        props = {
            style: 'currency',
            maximumFractionDigits: 2,
            currency: 'USD'
        }
    }
    
    return new Intl.NumberFormat('us-EN', props).format(val)
}

export function lengthLimit(txt = '', length) {
    const arr = [...txt]
    const arrLength = arr.length

    if(arrLength > length) {
        let diff = arrLength - length

        for(let i = 0; i < diff; i++) {
            arr.pop()
        }
        
        return arr.join('') + '...'
    }

    return txt
}

export function valuePlaceholder(val) {
    if(val !== 'NaN' && val !== 'NaN%' && val !== '$NaN') return val
    return '--'
}

export function showLoader(arr, render) {
    if(arr.filter(item => item === undefined || Number.isNaN(item)).length > 0) return `<zero-loader></zero-loader>`
    else { return render }
}

export function printWorkAround(component) {
    // Force background for printing / sigma PDF export. Call after <style> in render() of component
    return `
        <style>
            @media print {
                :host { background: none; isolation: isolate; }
            }
        </style>

        <svg 
            class="bg" 
            viewBox="0 0 10 10" 
            style="inset: 0 0 0 0; position: absolute; z-index: -1;">
            <rect x="0" y="0" width="10" height="10" fill="${component.bg}" />
        </svg>
    `
}